import { render, staticRenderFns } from "./moreTrainingUnit.vue?vue&type=template&id=53a6d6c4&scoped=true&"
import script from "./moreTrainingUnit.vue?vue&type=script&lang=js&"
export * from "./moreTrainingUnit.vue?vue&type=script&lang=js&"
import style0 from "./moreTrainingUnit.vue?vue&type=style&index=0&id=53a6d6c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a6d6c4",
  null
  
)

export default component.exports